export default "__VITE_ASSET__Bisc$UPB__"